import { combineReducers } from 'redux';
import blogReducer from './Blogs/blogReducer';
import filterReducer from './Filter/filterReducer';

const rootReducer = combineReducers({
  blogs: blogReducer,
  filter: filterReducer,
});

export default rootReducer;
